import { render, staticRenderFns } from "./RoomType.vue?vue&type=template&id=5884d41a&scoped=true"
import script from "./RoomType.vue?vue&type=script&lang=js"
export * from "./RoomType.vue?vue&type=script&lang=js"
import style0 from "./RoomType.vue?vue&type=style&index=0&id=5884d41a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5884d41a",
  null
  
)

export default component.exports